import angular from 'angular';
import brokerPediaIcon from './brokerPediaIcon';

export default angular
  .module('components.brokerPediaIcon', [])
  .component('brokerPediaIcon', brokerPediaIcon).name;
